<template>
  <div class="phone-selector">
    <div class="phone-input-container">
      <select
        v-model="selectedPrefix"
        @change="onPrefixChange"
        class="phone-prefix-select"
        :class="{ 'error': hasError }"
      >
        <option v-for="country in countries" :key="country.code" :value="country.dial_code">
          {{ country.dial_code }} {{ country.name }}
        </option>
      </select>

      <VeeField
        :id="fieldId"
        :name="fieldName"
        v-model="phoneNumber"
        @update:modelValue="onPhoneChange"
        type="text"
        :placeholder="placeholder"
        :rules="rules"
        class="phone-number-input"
        :class="{ 'error': hasError }"
      />
    </div>
    <ErrorMessage :name="fieldName" class="error" />
  </div>
</template>

<script>
import { Field as VeeField, ErrorMessage } from 'vee-validate';

export default {
  name: 'PhoneSelector',
  components: {
    VeeField,
    ErrorMessage
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    fieldId: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    rules: {
      type: String,
      default: 'required|phone'
    },
    defaultPrefix: {
      type: String,
      default: '+34'
    }
  },
  data() {
    return {
      selectedPrefix: this.defaultPrefix,
      phoneNumber: '',
      countries: [
        { code: 'ES', name: 'España', dial_code: '+34' },
        { code: 'FR', name: 'Francia', dial_code: '+33' },
        { code: 'IT', name: 'Italia', dial_code: '+39' },
        { code: 'DE', name: 'Alemania', dial_code: '+49' },
        { code: 'PT', name: 'Portugal', dial_code: '+351' },
        { code: 'GB', name: 'Reino Unido', dial_code: '+44' },
        { code: 'US', name: 'Estados Unidos', dial_code: '+1' },
        { code: 'AR', name: 'Argentina', dial_code: '+54' },
        { code: 'MX', name: 'México', dial_code: '+52' },
        { code: 'CO', name: 'Colombia', dial_code: '+57' },
        { code: 'PE', name: 'Perú', dial_code: '+51' },
        { code: 'CL', name: 'Chile', dial_code: '+56' },
        { code: 'BR', name: 'Brasil', dial_code: '+55' }
      ]
    };
  },
  computed: {
    hasError() {
      return false; // VeeField manejará los errores
    }
  },
  watch: {
    modelValue: {
      handler(newValue) {
        this.parsePhoneValue(newValue);
      },
      immediate: true
    }
  },
  methods: {
    parsePhoneValue(value) {
      if (!value) {
        this.selectedPrefix = this.defaultPrefix;
        this.phoneNumber = '';
        return;
      }

      // Buscar el prefijo en la lista de países
      const foundCountry = this.countries.find(country =>
        value.startsWith(country.dial_code)
      );

      if (foundCountry) {
        this.selectedPrefix = foundCountry.dial_code;
        this.phoneNumber = value.substring(foundCountry.dial_code.length);
      } else {
        // Si no encuentra el prefijo, usar el por defecto
        this.selectedPrefix = this.defaultPrefix;
        this.phoneNumber = value;
      }
    },
    onPrefixChange() {
      this.emitValue();
    },
    onPhoneChange() {
      this.emitValue();
    },
    emitValue() {
      const fullPhone = this.phoneNumber ? `${this.selectedPrefix}${this.phoneNumber}` : '';
      this.$emit('update:modelValue', fullPhone);
    }
  }
};
</script>

<style scoped>
.phone-selector {
  width: 100%;
}

.phone-input-container {
  display: flex;
  gap: 4px;
}

.phone-prefix-select {
  flex: 0 0 140px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
}

.phone-number-input {
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.phone-prefix-select.error,
.phone-number-input.error {
  border-color: #e74c3c;
}

.error {
  color: #e74c3c;
  font-size: 12px;
  margin-top: 4px;
}
</style>
